import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import CloseIcon from '@material-ui/icons/Close';
import { Card, CardHeader, IconButton, Slide } from "@material-ui/core";
import { masterHandleClose, APPVERSION } from "../common";
import { isBrowser, isIOS, isAndroid } from 'react-device-detect';
import "../styles/masterStyles.css";

const VersionBanner = props => { 
    if (props.auth && typeof props.user_details.appversion !== 'undefined') {
        let classes = 'aua-top-banner anchor active index100';
        let AppStoreVar = '.';
        let appversion = APPVERSION;

        if (isAndroid) { 
            classes += ' android'; 
            AppStoreVar = ' for Android Devices on the Play Store.'; 
            appversion = props.user_details.appversion.android; 
        } else if (isIOS) { 
            classes += ' ios'; 
            AppStoreVar = ' for iOS devices on the App Store.'; 
            appversion = props.user_details.appversion.ios; 
        } else {
            appversion += ' (Electron/Web app)'
        }
        if (!isBrowser || props.user_details.mcid === '00863273') {
            let subh = `SASP version ${appversion} is now available${AppStoreVar} Update your app today!`;
            return (
                <Slide mountOnEnter unmountOnExit
                    direction="down"
                    in={true}
                    id="VersionBanner"
                    className="aua-top-banner anchor active "
                >
                    <Card >
                        <CardHeader 
                            title={"Update Available!"}
                            subheader={subh}
                            action={
                                <IconButton
                                    className="firstButton"
                                    edge="start"
                                    aria-label="firstIcon"
                                    onClick={() => masterHandleClose('VersionBanner', 'active', 'inactive', 'sasp-hideVersion')}
                                    style={{backgroundColor: '#00567a', transform:"scale(0.5)"}}
                                >
                                    <CloseIcon className="headerIcons" />
                                </IconButton>
                            }
                        />
                    </Card>
                </Slide>
            );
        } else {
            return null;
        }
        
    } else {
        return null;
    }
};

const mapStateToProps = state => {
    const { auth, user_details } = state.auth;
    return { auth, user_details };
};

const VersionBannerCard = connect(mapStateToProps)(withRouter(VersionBanner));

export { VersionBannerCard }
